class Source {
  constructor() {
    this.embeddable = true
    this.inputs = {
      MAIN: "MAIN",
      VOD: "VOD",
      HLS: "HLS",
      MULTICAST: "MULTICAST",
      RF: "RF",
      HDMI1: "0",
      HDMI2: "1",
      HDMI3: "2",
      DVBT: "3",
      DVBC: "4",
      DVBS: "5",
      ATV: "10"
    }
  }
  async _init() {
    if (!playmore?.device?.sources) return true

    try {
      const rawSources = playmore.device.sources()
      const sources = JSON.parse(rawSources || "{}")
      Object.keys(sources).forEach(key => {
        this.inputs[key] = `${sources[key]}`
      })
    } catch (err) {
      _$.error(err)
    }

    return true
  }

  async get() {
    if (__.platform.focus) return this.inputs.MAIN
    if (!playmore?.device?.getSource) return this.inputs.MAIN

    const promise = await _$.progress.create()
    promise.terminateAfter(3000)

    _$.vue.$once(["getCurrentSourceSystemMessage"], res => promise.resolve(res))
    playmore.device.getSource()

    let source = await promise.done
    if (!source) return this.inputs.MAIN

    source = source.replace("_", "").replace("HDMI4", "HDMI2")
    return this.inputs[source] || this.inputs.MAIN
  }
  async set(source) {
    if (source == this.inputs.MAIN) {
      playmore.platform.returnToPlatform()
      _$.handler.emit("source_event", this.inputs.MAIN)
      return true
    }

    if (!playmore?.device?.setSource) return false

    const sourceInt = parseInt(source, 10)
    if (isNaN(sourceInt)) return false

    const promise = await _$.progress.create()
    promise.terminateAfter(3000)
    _$.vue.$once(["setSwitchSourceSystemMessage"], res => (res === "OK" ? promise.resolve() : promise.reject()))

    playmore.device.setSource(sourceInt)

    const res = await promise.done
    if (!res) return false

    _$.handler.emit("source_event", `${sourceInt}`)
    return true
  }
}

export default Source
